






















































































import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import newView from '@common/client/src/newView'
import { countdown as datetimeCountdown } from '@finance/datetime'

import {
  getBtnStatus,
  getTaskBtnConfig,
  uiComponentCodeConfig,
  behaviorCodeConfig,
} from '$utils/task-adapter'
import { getTargeTimestamp } from '$utils/free-order'
import IndexMixin from '$utils/mixins/index'
import { behaviorComplete, synRuleDrawEnhance, ruleReachDraw, ACT_CODE } from '$services/free-order'
import Reporter from '$services/user-reporter'

// 新人引导上报工具
const guideReporter = new Reporter(ACT_CODE, `${ACT_CODE}_GUIDE_NODE_CODE`)

const actModule = namespace('freeOrder')

@Component({
  name: 'task-list',
  components: {
  },
})

export default class TaskLists extends IndexMixin {
  @actModule.Getter('actConfig') actConfig!: any
  @actModule.Getter('actRunning') actRunning!: boolean
  @actModule.Getter('actRuningDayNum') actRuningDayNum!: number
  @actModule.Getter('actRedRainStatus') actRedRainStatus!: number
  @actModule.Getter('isRedRainSecondPartedIn') isRedRainSecondPartedIn!: boolean
  @actModule.Getter('signInData') signInData!: any
  @actModule.Getter('signInTask') signInTask!: any
  @actModule.Getter('showTaskLists') showTaskLists!: any
  @actModule.Getter('redPacketsRainTask') redPacketsRainTask!: any
  @actModule.Getter('bookFlag') bookFlag!: boolean
  @actModule.Getter('isShowGuide') isShowGuide!: boolean
  @actModule.State('breathe') breathe!: boolean

  @Watch('signInTask')
  onSignInTask() {
    this.newUserGuide()
  }

  uiComponentCodeConfig = uiComponentCodeConfig
  timeDownId: any = null
  timeDownTime = -1
  currentTime = new Date().getTime() // 当前保存的时间
  redPackeShowTime: string | false = '' // 红包雨展示的倒计时时间

  // 倒计时改变
  @Watch('timeDownTime')
  onTimeDownTimeChange() {
    if (this.timeDownTime > this.currentTime) {
      this.redPackeShowTime = datetimeCountdown({
        timestamp: this.timeDownTime,
        current: this.currentTime,
        format: 'hh:mm:ss'
      })
    } else {
      this.redPackeShowTime = '00:00:00'
    }
  }

  // 红包雨倒计时
  redPacketTimeDown() {
    // 已经开始倒计时，直接返回
    if (this.timeDownId) {
      return
    }
    const { currentTime } = this.actConfig
    const firstTime = getTargeTimestamp(currentTime, 7, 0)
    const secondTime = getTargeTimestamp(currentTime, 18, 0)

    this.currentTime = currentTime
    if (this.actRedRainStatus === 0) {
      this.timeDownTime = firstTime
    } else {
      this.timeDownTime = secondTime
    }
    console.log('this.timeDownTime', this.timeDownTime)
    this.timeDownId = setInterval(() => {
      if (this.timeDownTime > this.currentTime) {
        this.timeDownTime -= 1000
      } else {
        this.timeDownId = null
        clearInterval(this.timeDownId)
        this.$store.dispatch('freeOrder/bootstrap', { force: true })
      }
    }, 1000)
  }

  // 红包雨按钮文案
  get redPacketBtnText() {
    const {
      completedNums,
      status,
    } = this.redPacketsRainTask
    // 活动进行中，取配置的状态文案
    if (this.actRunning) {
      // 活动大于等于6天且已完成任务，按钮文案为已完成
      if (status === 2 && this.actRuningDayNum >= 6) {
        return '已完成'
      } else {
        // 特殊处理红包雨
        let btnText
        if (status === 2) {
          // 最后一天
          if (this.actRuningDayNum >= 6) {
            btnText = '已完成'
          } else {
            btnText = '明天再来'
          }
        } else if (this.actRedRainStatus === 0) {
          btnText = this.redPackeShowTime
          this.redPacketTimeDown()
        } else if (this.actRedRainStatus === 1) {
          if (completedNums === 1) {
            btnText = this.redPackeShowTime
            this.redPacketTimeDown()
          } else {
            btnText = '抢红包'
          }
        } else if (completedNums === 2 || this.isRedRainSecondPartedIn) {
          // 最后一天
          if (this.actRuningDayNum >= 6) {
            btnText = '已完成'
          } else {
            btnText = '明天再来'
          }
        } else {
          btnText = '抢红包'
        }
        return btnText
      }
    } else {
      return '已结束'
    }
  }

  // 获取按钮展示文案
  getBtnShowText(task: any) {
    const {
      uiComponentCode,
    } = task
    // 活动进行中，取配置的状态文案
    if (this.actRunning) {
      // 活动大于等于6天且已完成任务，按钮文案为已完成
      if (task.status === 2 && this.actRuningDayNum >= 6) {
        return '已完成'
      } else {
        const status = getBtnStatus(task.status)
        const btnText = getTaskBtnConfig(uiComponentCode, status)
        return btnText
      }
    } else {
      return '已结束'
    }
  }
  // 获取按钮展示状态
  getBtnShowStatus(item: any) {
    const {
      uiComponentCode,
      completedNums,
    } = item
    // 活动进行中，取配置的状态文案
    if (this.actRunning) {
      // 禁用状态：2已完成 3无资格
      if (item.status === 2 || item.status === 3) {
        return 'disabled'
      } else {
        // 特殊处理红包雨
        if (uiComponentCode === uiComponentCodeConfig.RED_PACKETS_RAIN) {
          if (this.actRedRainStatus === 0
            || (this.actRedRainStatus === 1 && completedNums === 1)
            || (this.actRedRainStatus === 2 && this.isRedRainSecondPartedIn)
          ) {
            return 'disabled'
          }
          return ''
        }
        return ''
      }
    } else {
      return 'disabled'
    }
  }
  // 获取按钮动效状态
  getBtnAnimStatus(item: any, key: number) {
    if (item.status === 1 && key === 0 && this.breathe) {
      return 'anim-breathing'
    }
    return ''
  }
  // 获取签到图标class字符串
  getSignInIconClass(item: any) {
    let classStr
    if (item.status === 1) {
      classStr = 'icon-fire-disabled'
    } else if (item.status === 2) {
      classStr = 'icon-fire'
    } else {
      classStr = 'icon-sign'
    }
    return classStr
  }
  // 获取签到火力值class
  getSignInFireClass(item: any) {
    let classStr
    if (item.status === 1) {
      classStr = 'sign'
    } else if (item.status === 3) {
      classStr = 'sign'
    } else {
      classStr = ''
    }
    return classStr
  }
  // 更新签到火力值动画
  updateSignInFirePosition() {
    const key = this.signInData.findIndex((item: any) => {
      return item.isToday === true
    })
    const fireItem: any = this.$refs[`signInFire${key}`]
    if (fireItem && fireItem[0]) {
      const targetFire = fireItem[0].getBoundingClientRect()
      this.$store.commit('freeOrder/updateFireXYZ', {
        x: targetFire.x,
        y: targetFire.y
      })
    }
  }
  // 每日签到
  async doSignIn() {
    // 判断活动是否进行中
    if (this.actRunning) {
      if (this.signInTask.status === 1) {
        const btnFlag = await this.btnCommonHandle()
        if (!btnFlag) {
          return
        }

        if (this.isShowGuide) {
          this.$Collect.trackEvent('2020双12新人引导页_签到领奖')
          this.$store.commit('freeOrder/updateIsShowGuide', false)
        } else {
          this.$Collect.trackEvent('2020双12任务列表_签到领奖_点击')
        }
        synRuleDrawEnhance({
          uiComponentCodes: [this.signInTask.uiComponentCode],
          ruleGroupCodes: [this.signInTask.ruleGroupCode],
          extParams: {
            clickNo: 0,
            dayNo: this.actRuningDayNum >= 6 ? 6 : this.actRuningDayNum
          }
        }).then((result: any) => {
          if (result.resultCode === '000000') {
            this.updateSignInFirePosition()
          } else {
            this.$ssvue.toast.show({
              text: '领取失败，请稍后重试',
              time: 3000,
            })
          }
        }).catch((error: any) => {
          console.log('synRuleDrawEnhance', error)
          this.$ssvue.toast.show({
            text: '网络异常，请稍后重试',
            time: 3000,
          })
        })
      }
    } else {
      this.$ssvue.toast.show({
        text: '活动已结束',
        time: 3000,
      })
    }
  }
  // 点击任务
  async handleClickTaskBtn(task: any, index: number) {
    const { status, gotoUrl, uiComponentCode, ruleGroupCode, showIsBehavior, completedNums, showTaskName, showIsLocation } = task
    const fireItem: any = this.$refs[`fireNum${index}`]

    // 判断活动是否进行中
    if (this.actRunning) {
      // 未参与
      if (status === 1) {
        const btnFlag = await this.btnCommonHandle()
        if (!btnFlag) {
          return
        }

        this.$Collect.trackEvent(`2020双12任务列表_${showTaskName}_去看看_点击`)
        // 记一笔
        if (uiComponentCode === uiComponentCodeConfig.ACCOUNT_BOOK) {
          this.taskBook()
        } else if (uiComponentCode === uiComponentCodeConfig.RED_PACKETS_RAIN) {
          // 红包雨 第二场已参与不能点击
          if ((this.actRedRainStatus > completedNums)
            && (this.actRedRainStatus !== 2 || (this.actRedRainStatus === 2 && !this.isRedRainSecondPartedIn))) {
            // 更新任务火力值动画
            if (fireItem && fireItem[0]) {
              const targetFire = fireItem[0].getBoundingClientRect()
              this.$store.commit('freeOrder/updateRunConf', {
                run: true,
                uiComponentCode,
                ruleGroupCode,
                x: targetFire.x,
                y: targetFire.y
              })
            } else {
              this.$store.commit('freeOrder/updateRunConf', {
                run: true,
                uiComponentCode,
                ruleGroupCode,
              })
            }
          }
        } else if (showIsBehavior) {
          // 需要上报行为再做跳转
          // @ts-ignore
          behaviorComplete(behaviorCodeConfig[uiComponentCode]).then(() => {
            if (showIsLocation) {
              // 直接跳转
              window.location.href = gotoUrl
            } else {
              newView(gotoUrl)
            }
          }).catch((error: any) => {
            console.log('直接上报任务失败', error)
          })
        } else if (showIsLocation) {
          // 直接跳转
          window.location.href = gotoUrl
        } else {
          newView(gotoUrl)
        }
      } else if (status === 4) {
        const btnFlag = await this.btnCommonHandle()
        if (!btnFlag) {
          return
        }

        this.$Collect.trackEvent(`2020双12任务列表_${showTaskName}_去看看_领取`)
        ruleReachDraw({
          ruleGroupCode,
        }).then(async(result: any) => {
          if (result.resultCode === '000000') {
            // 更新任务火力值动画
            if (fireItem && fireItem[0]) {
              const targetFire = fireItem[0].getBoundingClientRect()
              this.$store.commit('freeOrder/updateFireXYZ', {
                x: targetFire.x,
                y: targetFire.y
              })
            }
          } else {
            this.$ssvue.toast.show({
              text: '领取失败，请稍后重试',
              time: 3000,
            })
          }
        }).catch((error: any) => {
          console.log('synRuleDrawEnhance', error)
          this.$ssvue.toast.show({
            text: '网络异常，请稍后重试',
            time: 3000,
          })
        })
      }
    } else {
      this.$ssvue.toast.show({
        text: '活动已结束',
        time: 3000,
      })
    }
  }
  // 记一笔
  taskBook() {
    // 更新记一笔标识
    this.$store.commit('freeOrder/updateBookFlag', true)
    const that = this
    window.sui.ready(() => {
      window.sui && window.sui.registerEventObserver && window.sui.registerEventObserver({
        event: 'addTransaction',
        success(res: any) {
          console.warn('success', res)
          behaviorComplete(behaviorCodeConfig.ACCOUNT_BOOK).then(() => {
            that.$ssvue.toast.show({
              text: '记账数据同步中，稍等几秒即可领取奖励～',
              time: 3000,
            })
          }).catch((error: any) => {
            that.$ssvue.toast.show({
              text: '网络异常，请稍后重试',
              time: 3000,
            })
            console.log('记一笔上报错误', error)
          })
        },
        error(err: any) {
          console.warn('记一笔失败', err)
        }
      })
      window.location.href = 'https://t.feidee.com/addTrans'
    })
  }
  // 新人引导
  newUserGuide() {
    if (this.signInTask.status === 1 && this.actRunning && this.isLogin) {
      guideReporter.get().then((data: any) => {
        console.log(data)
        const flag = data && data.length > 0
        console.log('flag', flag)
        if (!flag) {
          this.$Collect.trackView('2020双12新人引导页_浏览')
          this.$store.commit('freeOrder/updateIsShowGuide', true)
          guideReporter.set()
        }
      })
    }
  }
  // 关闭新人引导
  closeNewUserGuide() {
    this.$Collect.trackEvent('2020双12新人引导页_点击任意处')
    this.$store.commit('freeOrder/updateIsShowGuide', false)
  }
  // 运营位class
  get operationTaskClass() {
    if (this.actRuningDayNum % 2 === 1) {
      return 'odd'
    } else {
      return 'even'
    }
  }
  // 运营位点击
  async operationTaskClick() {
    const btnFlag = await this.btnCommonHandle()
    if (!btnFlag) {
      return
    }

    this.$Collect.trackEvent('2020双12任务列表_双十二活动页Banner_点击')
    newView('https://s.click.taobao.com/pGWFTtu')
  }
  mounted() {
  }
  destroyed() {
    this.timeDownId = null
    clearInterval(this.timeDownId)
  }
}
